import { Capacitor } from '@capacitor/core';

/** Installed PWA (Add to Home Screen) — not a normal browser tab. */
export function isStandalonePwa() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches ||
    window.matchMedia?.('(display-mode: fullscreen)').matches ||
    window.navigator.standalone === true
  );
}

/** Long-lived login: native app or installed PWA only. */
export function wantsPersistentSession() {
  if (Capacitor.isNativePlatform()) return true;
  return isStandalonePwa();
}
